import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenInventoryPageBreadcrumbs } from '@/pages/Inventory/config';
import { NavigateFunction } from 'react-router-dom';

export const usersPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
  { label: 'Usuarios', onClick: () => navigate('/inventory/users') },
];
